import React, { Component } from 'react';
import { connect } from 'react-redux';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
import Tooltip from '@material-ui/core/Tooltip';
// import Autocomplete from '@material-ui/lab/Autocomplete';
import Select from "@material-ui/core/Select";
import moment from 'moment';
import 'rc-time-picker/assets/index.css';
import TimePicker from 'rc-time-picker';
import Typography from '@material-ui/core/Typography';

import getProfileFetch from '../actions/profile_actions';

// import { withStyles } from '@material-ui/styles';
import '../../src/index.css';

/*
const styles = theme => ({
    inputRoot: {
        //backgroundColor: "pink",
        //"& .MuiAutocomplete-option": {
        //  backgroundColor: "pink"
        //},
        //color: "purple",
        //"& .MuiOutlinedInput-notchedOutline": {
        //  borderColor: "green"
        //},
        //"&:hover .MuiOutlinedInput-notchedOutline": {
        //  borderColor: "red"
        //},
        //"&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        //  borderColor: "purple"
        //}
    }
});
*/

// Compact rows for the away-message list: MUI v4 MenuItem defaults to a 48px
// touch target, which makes 14 options taller than the dialog can show.
const awayOptionStyle = { padding: '4px 12px', minHeight: '28px', fontSize: '13px' };

// How long until the chosen return time, never negative. The picker is
// rc-time-picker, a time of day with no date - its moment sits on today - so
// "back by 8:00 am" chosen at 5 pm means tomorrow morning, and that is how a
// time already past is read. Taken as "now" instead it fired the elapsed
// dialog the moment the away message was saved. Rolled forward through
// moment so a daylight-saving change does not move the hour. null when there
// is no time to wait for.
export const msUntilReturn = (returnMs, nowMs) => {
    if (typeof returnMs !== 'number' || isNaN(returnMs)) {
        return null;
    }
    var target = moment(returnMs);
    if (target.valueOf() <= nowMs) {
        target = target.add(Math.floor((nowMs - target.valueOf()) / 86400000), 'days');
    }
    while (target.valueOf() <= nowMs) {
        target = target.add(1, 'days');
    }
    return target.valueOf() - nowMs;
};

// Whether a profile is in the away state the return timer belongs to: an away
// message set, and a status that still means it. Disconnected counts - see
// componentDidUpdate.
export const isAway = (profile) => {
    if (!profile || !profile.awayMessage) {
        return false;
    }
    return profile.status === 'Busy' || profile.status === 'Disconnected';
};

export class UserInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            anchorEl: null,
            open: false,
            profile: this.props.profile,
            tempAwayMessage: "",
            tempAwayTime: "",
            showInvalidError: false,
            value: moment(),
            returnTimeMilliseconds: null,
            setTimeoutActive: false,
            showChangeStatusDialog: false,
        };
    }

    // Opens the menu.
    handleClick = event => {
        // MUI v4 puts aria-hidden on #root the instant a modal opens, which is
        // before its focus trap has had a chance to move focus. Chrome then
        // refuses to apply it, because the button that opened the menu is still
        // focused inside the subtree being hidden - leaving the whole app behind
        // the menu readable to screen readers. Letting go of focus first keeps
        // the modal properly isolated; restoreTriggerFocus hands it back once
        // everything has closed, so keyboard users do not lose their place.
        this.triggerEl = event.currentTarget;
        this.setState({ anchorEl: event.currentTarget });
        this.triggerEl.blur();
    };

    // Closes the menu.
    handleClose = () => {
        this.setState({ anchorEl: null });
        this.setState({ anchorEl: null });
    };

    // Called from onExited, so it runs after the closing transition has finished
    // and after MUI has done its own focus restoration - anything earlier gets
    // overwritten. Choosing a status opens the away dialog as the menu closes,
    // so hold off while anything of ours is still up; whichever closes last
    // brings focus home.
    restoreTriggerFocus = () => {
        if (this.state.anchorEl || this.state.open || this.state.showChangeStatusDialog) {
            return;
        }
        if (this.triggerEl) {
            this.triggerEl.focus();
        }
    };

    // Opens the away message dialog.
    handleDialogOpen = () => {
        this.setState({ open: true });
    };

    handleDialogClose = () => {
        this.setState({ tempAwayMessage: "" });
        this.setState({ open: false });
        this.setState({ showInvalidError: false });
    };

    handleInAvailable = () => {
        this.setState({
            anchorEl: null,
        }, () => {
            var updatedUser = { ...this.props.profile };
            updatedUser["Status"] = "Available";
            updatedUser["inOffice"] = true; //online
            updatedUser['awayMessage'] = "";
            updatedUser['awayTime'] = "";
            this.props.updateProfile(updatedUser);
            //window.location.reload();
            this.handleClearSetTimeoutActive();
        });
    }

    handleUnavailable = () => {
        this.setState({
            anchorEl: null,
        }, () => {
            var updatedUser = { ...this.props.profile };
            updatedUser["Status"] = "Busy";
            updatedUser["inOffice"] = true; //online
            updatedUser["awayMessage"] = "";
            this.props.updateProfile(updatedUser);
            this.handleClearSetTimeoutActive();
        });
    }

    handleInBusy = () => {
        this.setState({
            anchorEl: null,
            open: true,
            value: moment(),
        });
    }

    handleOutBusy = () => {
        this.setState({
            anchorEl: null,
            open: true,
        }, () => {
            var updatedUser = { ...this.props.profile };
            updatedUser["Status"] = "Busy";
            updatedUser["inOffice"] = false; //offline
            this.props.updateProfile(updatedUser);
        });
    }

    handleOutDone = () => {
        this.setState({
            anchorEl: null,
        }, () => {
            var updatedUser = { ...this.props.profile };
            updatedUser["Status"] = "Done";
            updatedUser["inOffice"] = false;  //offline
            updatedUser['awayMessage'] = "";
            updatedUser['awayTime'] = "";
            this.props.updateProfile(updatedUser);
            this.handleClearSetTimeoutActive();
        });
    }

    handleChange = property => event => {
        if (property === 'awayMessage') {
            this.setState({ tempAwayMessage: event.target.value });
        } else {
            this.setState({ tempAwayTime: event.target.value }); // 24-hr time HH:MM string
            // convert 24-hr to 12-hr AM/PM
            //var suffix = Number(event.target.value.substring(0, 2)) >= 12 ? " PM" : " AM";
            //var hours = ((Number(event.target.value.substring(0, 2)) + 11) % 12 + 1) + ":" + event.target.value.substring(3, 5) + suffix;
            //console.log(hours);
            //this.setState({ tempAwayTime: hours }); // error: speficied value "2:00 PM" does not conform to the required format bc of suffix?
        }
    };

    // handleChangeAutocomplete = (event, value) => {
    handleChangeAutocomplete = (event) => {
        this.setState({ tempAwayMessage: event.target.value });
    };

    // rc-time-picker
    handleValueChange = value => {
        this.setState({ value });
        this.setState({ returnTimeMilliseconds: Date.parse(value._d) });
        this.setState({ tempAwayTime: value.format('h:mm a') });
    };

    //handleTimePicker = (e) => {
    //  console.log("e.target.value: ", e.target.value); // 24-hr time HH:MM
    //};

    handleDialogOK = () => {
        if (this.state.tempAwayMessage === "" || this.state.tempAwayTime === "") {
            this.setState({ showInvalidError: true });
        } else {
            this.setState({
                open: false,
                showInvalidError: false,
            }, () => {
                var updatedUser = { ...this.props.profile };
                updatedUser['awayMessage'] = this.state.tempAwayMessage;
                updatedUser['awayTime'] = this.state.tempAwayTime;
                updatedUser["Status"] = "Busy";
                updatedUser["inOffice"] = true;  //online
                this.setState({ tempAwayMessage: "", tempAwayTime: "" });
                this.props.updateProfile(updatedUser);
            });
            this.setState({ setTimeoutActive: true }, () => {
                this.toggleSetTimeout(); // Calls the function that will start setTimeout if this.state.setTimeoutActive is true
            });
        }
    };

    // Determines whether to initiate setTimeout or clear it
    toggleSetTimeout = () => {
        // Always clear first: setting a second away message while the first
        // was still pending used to overwrite this.timer and leave the old one
        // running, so the first deadline still popped the dialog.
        clearTimeout(this.timer);
        this.timer = null;
        if (this.state.setTimeoutActive) {
            var timeInterval = msUntilReturn(this.state.returnTimeMilliseconds, Date.now());
            if (timeInterval !== null) {
                this.timer = setTimeout(this.openChangeStatusDialog, timeInterval);
            }
        }
    };

    // The return timer belongs to an away status, and that status can end
    // somewhere other than this component's own handlers - the idle timer in
    // App, another device, an admin. Only those handlers used to clear it, so
    // the "return time has elapsed" dialog still came up later for an away
    // message that was already gone.
    //
    // Disconnected is not counted as leaving: the presence sweep sets it
    // while keeping the away message, and the next heartbeat restores the
    // status from StatusBeforeDisconnect, so the user is still away.
    componentDidUpdate(prevProps) {
        if (!this.state.setTimeoutActive && !this.state.showChangeStatusDialog) {
            return;
        }
        if (isAway(prevProps.profile) && !isAway(this.props.profile)) {
            clearTimeout(this.timer);
            this.timer = null;
            this.setState({ setTimeoutActive: false, showChangeStatusDialog: false });
        }
    }

    componentWillUnmount() {
        clearTimeout(this.timer);
        this.timer = null;
    }

    // Opens change status dialog when setTimeout is executed
    openChangeStatusDialog = () => {
        this.setState({ showChangeStatusDialog: true });
    };

    // Closes change status dialog after clicking OK
    closeChangeStatusDialog = () => {
        this.setState({ showChangeStatusDialog: false });
    };

    // Clears the setTimeout when user changes their status to Available or Back after being Away
    handleClearSetTimeoutActive = () => {
        if (this.state.setTimeoutActive) {
            this.setState({ setTimeoutActive: false }, () => {
                this.toggleSetTimeout();
            });
        }
    };

    handleClearTextFields = () => {
        //console.log("clearing text fields");
        this.setState({ tempAwayMessage: "" });
        this.setState({ tempAwayTime: "" });
    };

    // Changes their status without a message/time
    handleDialogNoMessage = () => {
        this.setState({
            open: false, showInvalidError: false, tempAwayTime: "", tempAwayMessage: ""
        }, () => {
            var updatedUser = { ...this.props.profile };
            //console.log("updatedUser: ", updatedUser);
            updatedUser['awayMessage'] = this.state.tempAwayMessage;
            updatedUser['awayTime'] = this.state.tempAwayTime;
            this.props.updateProfile(updatedUser);
        });
    };

    handleAddMinutes = () => {
        this.setState({ value: moment().add(15, 'minutes') }, () => {
            this.setState({ returnTimeMilliseconds: Date.parse(this.state.value._d) });
            this.setState({ tempAwayTime: this.state.value.format('h:mm a') });
        });
    };

    handleAddHalfHour = () => {
        this.setState({ value: moment().add(30, 'minutes') }, () => {
            this.setState({ returnTimeMilliseconds: Date.parse(this.state.value._d) });
            this.setState({ tempAwayTime: this.state.value.format('h:mm a') });
        });
    };

    handleAddHour = () => {
        this.setState({ value: moment().add(1, 'hours') }, () => {
            this.setState({ returnTimeMilliseconds: Date.parse(this.state.value._d) });
            this.setState({ tempAwayTime: this.state.value.format('h:mm a') });
        });
    };

    render() {

        const { anchorEl } = this.state;
        const status = this.props.profile.status;
        const inOffice = this.props.profile.inOffice; // online
        const hasAwayMessage = this.props.profile.awayMessage !== "";
        const format = 'h:mm a';
        /*
        const standardMessages = [
            { title: 'Away' },
            { title: 'Bank' },
            { title: 'Break' },
            { title: 'Lunch' },
            { title: 'Meeting' },
            { title: 'Meeting Conf Room' },
            { title: 'Post Office' },
        ];
        */
        let button;
        let invalidError;
        let availableButton;
        let awayButton;
        let unavailableButton;

        if (inOffice === true && status === "Available") { // online && "Available"
            button =
                <Tooltip
                    placement="bottom"
                    title={
                        <React.Fragment>
                            <h6>
                                You are: Available
                  </h6>
                        </React.Fragment>
                    }
                >
                    <i className="material-icons" style={{ color: '#4dd691' }}>check_circle</i>
                </Tooltip>;
        } else if (inOffice === true && status === "Busy" && hasAwayMessage === false) {
            button =
                <Tooltip
                    placement="bottom"
                    title={
                        <React.Fragment>
                            <h6>
                                You are: Unavailable
                  </h6>
                        </React.Fragment>
                    }
                >
                    <i className="material-icons" style={{ color: '#ff9400' }}>access_time</i>
                </Tooltip>;
        } else if (inOffice === true && status === "Busy" && hasAwayMessage === true) {
            button =
                <Tooltip
                    placement="bottom"
                    title={
                        <React.Fragment>
                            <h6>
                                You are: Away
                  </h6>
                        </React.Fragment>
                    }
                >
                    <i className="material-icons" style={{ color: '#ff9400' }}>access_time</i>
                </Tooltip>;
        } else if (inOffice === false && status === "Busy") {
            button =
                <Tooltip
                    placement="bottom"
                    title={
                        <React.Fragment>
                            <h6>
                                You are: Unavailable
                  </h6>
                        </React.Fragment>
                    }
                >
                    <i className="material-icons" style={{ color: '#c94e4e' }}>remove_circle_outline</i>
                </Tooltip>;
        } else if (inOffice === false && status === "Done") {
            button =
                <Tooltip
                    placement="bottom"
                    title={
                        <React.Fragment>
                            <h6>
                                You are: Offline
                  </h6>
                        </React.Fragment>
                    }
                >
                    <i className="material-icons" style={{ color: '#c4c4c4' }}>highlight_off</i>
                </Tooltip>;
        } else if (inOffice === false && status === "Disconnected") {
            button =
                <Tooltip
                    placement="bottom"
                    title={
                        <React.Fragment>
                            <h6>
                                You are: Disconnected
                  </h6>
                        </React.Fragment>
                    }
                >
                    <i className="material-icons" style={{ color: '#c4c4c4' }}>warning</i>
                </Tooltip>;
        }
        // A pair none of the branches above name - a presence sweep and its
        // undo once produced inOffice=false with status "Available". Without
        // a button there is no menu, so the user could not even pick a status
        // to get out of it. Show what the server says and keep the menu.
        else {
            button =
                <Tooltip
                    placement="bottom"
                    title={
                        <React.Fragment>
                            <h6>
                                You are: {status}
                  </h6>
                        </React.Fragment>
                    }
                >
                    <i className="material-icons" style={{ color: '#c4c4c4' }}>help_outline</i>
                </Tooltip>;
        }

        if (this.state.showInvalidError) {
            invalidError = <div style={{ color: 'red', fontSize: '10px' }}>Please enter away message and return time!</div>;
        } else {
            invalidError = <div></div>;
        }

        if ((inOffice && (hasAwayMessage || status === "Busy")) || !inOffice) {
            availableButton = <MenuItem onClick={this.handleInAvailable} style={{ padding: '5px 10px', fontSize: '12px', minHeight: '25px' }}>Available</MenuItem>;
        } else {
            availableButton = <div></div>;
        }

        if (inOffice && (status === "Available" || (!hasAwayMessage && status === "Busy"))) {
            awayButton = <MenuItem onClick={this.handleInBusy} style={{ padding: '5px 10px', fontSize: '12px', minHeight: '25px' }}>Away</MenuItem>;
        } else {
            awayButton = <div></div>;
        }

        if (inOffice && hasAwayMessage) {
            unavailableButton = <MenuItem onClick={this.handleUnavailable} style={{ padding: '5px 10px', fontSize: '12px', minHeight: '25px' }}>Back</MenuItem>;
        } else if (inOffice && status === "Available") {
            unavailableButton = <MenuItem onClick={this.handleUnavailable} style={{ padding: '5px 10px', fontSize: '12px', minHeight: '25px' }}>Unavailable</MenuItem>;
        } else {
            unavailableButton = <div></div>;
        }

        const { classes } = this.props;

        return (
            <div>

                <Grid container spacing={0}>

                    <Grid item xs={3}>
                        {/*<Tooltip
              placement="bottom"
              title={
                <React.Fragment>
                  <h6>
                    Change Your Status
                  </h6>
                </React.Fragment>
              }
            >
            */}
                        <IconButton
                            aria-owns={anchorEl ? 'simple-menu2' : undefined}
                            aria-haspopup="true"
                            onClick={this.handleClick}
                        >
                            {button}
                        </IconButton>
                        {/*</Tooltip>*/}

                        <Dialog
                            open={this.state.open}
                            //onClose={this.handleDialogClose}
                            aria-labelledby="form-dialog-title"
                            PaperProps={{ style: { minWidth: '195px' } }}
                            TransitionProps={{ onExited: this.restoreTriggerFocus }}
                        >
                            <DialogTitle id="form-dialog-title" style={{ paddingTop: '5px', paddingLeft: '5px', paddingBottom: '0px' }}>Away Message</DialogTitle>
                            <DialogContent style={{ paddingLeft: '5px', paddingRight: '5px', paddingBottom: '0px', paddingTop: '0px' }}>
                                <Select
                                    required
                                    style={{ padding: '5px', marginTop: '5px' }}
                                    onChange={this.handleChangeAutocomplete}
                                    label="Message"
                                    fullWidth
                                    type="string"
                                    id="message"
                                    value={this.state.tempAwayMessage}
                                >
                                    <MenuItem style={awayOptionStyle} value={"Admin"}>Admin</MenuItem>
                                    <MenuItem style={awayOptionStyle} value={"Away"}>Away</MenuItem>
                                    <MenuItem style={awayOptionStyle} value={"Bank"}>Bank</MenuItem>
                                    <MenuItem style={awayOptionStyle} value={"Break"}>Break</MenuItem>
                                    <MenuItem style={awayOptionStyle} value={"Finishing"}>Finishing</MenuItem>
                                    <MenuItem style={awayOptionStyle} value={"Front Modular"}>Front Modular</MenuItem>
                                    <MenuItem style={awayOptionStyle} value={"Lunch"}>Lunch</MenuItem>
                                    <MenuItem style={awayOptionStyle} value={"Meeting"}>Meeting</MenuItem>
                                    <MenuItem style={awayOptionStyle} value={"Meeting Conf Room"}>Meeting Conf Room</MenuItem>
                                    <MenuItem style={awayOptionStyle} value={"Post Office"}>Post Office</MenuItem>
                                    <MenuItem style={awayOptionStyle} value={"Production"}>Production</MenuItem>
                                    <MenuItem style={awayOptionStyle} value={"Sales Room"}>Sales Room</MenuItem>
                                    <MenuItem style={awayOptionStyle} value={"Doctor"}>Doctor</MenuItem>
                                    <MenuItem style={awayOptionStyle} value={"Other"}>Other</MenuItem>
                                </Select>
                                {/*
                                <Autocomplete
                                    style={{ padding: '0px' }}
                                    onChange={this.handleChangeAutocomplete}
                                    id="free-solo-demo"
                                    freeSolo
                                    options={standardMessages.map(option => option.title)}
                                    //ListboxProps={{ style: { minHeight: '25px' } }}
                                    //ListboxComponent={ListboxComponent}

                                    // className={classes.inputRoot}
                                    renderInput={params => (
                                        <TextField {...params}
                                            required
                                            label="Message"
                                            margin="normal"
                                            fullWidth
                                            type="string"
                                            id="message"
                                            value={this.state.tempAwayMessage}
                                            onChange={this.handleChange('awayMessage')}
                                            style={{ marginTop: '5px' }}
                                        />
                                    )}
                                />
                                */}
                                {/*
                <TextField
                  autoFocus
                  required
                  margin="normal"
                  id="message"
                  label="Message"
                  type="string"
                  fullWidth
                  value={this.state.tempAwayMessage}
                  onChange={this.handleChange('awayMessage')}
                  style={{ marginTop: '5px' }}
                />
                */}

                                {/*
                <TextField
                  required
                  margin="normal"
                  id="time"
                  label="Back by"
                  type="string"
                  fullWidth
                  value={this.state.tempAwayTime}
                  onChange={this.handleChange('awayTime')}
                  style={{ marginTop: '5px' }}
                />
                */}

                                <p style={{ fontSize: '10px', marginTop: '10px', marginBottom: '3px', fontWeight: 'bold' }}>Return Time</p>

                                <div>
                                    <Grid container justifyContent="center" spacing={0}>
                                        <Grid item xs={4} style={{}}>
                                            <Tooltip
                                                placement="bottom"
                                                title={
                                                    <React.Fragment>
                                                        <h6>
                                                            Add 15 minutes
                            </h6>
                                                    </React.Fragment>
                                                }
                                            >
                                                <Button size="small" onClick={this.handleAddMinutes} style={{ padding: '0px', marginBottom: '5px' }}>
                                                    <Typography>+ 15min</Typography>
                                                </Button>
                                            </Tooltip>
                                        </Grid>
                                        <Grid item xs={4} style={{}}>
                                            <Tooltip
                                                placement="bottom"
                                                title={
                                                    <React.Fragment>
                                                        <h6>
                                                            Add 30 minutes
                            </h6>
                                                    </React.Fragment>
                                                }
                                            >
                                                <Button size="small" onClick={this.handleAddHalfHour} style={{ padding: '0px', marginBottom: '5px' }}>
                                                    <Typography>+ 30min</Typography>
                                                </Button>
                                            </Tooltip>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Tooltip
                                                placement="bottom"
                                                title={
                                                    <React.Fragment>
                                                        <h6>
                                                            Add 1 hour
                            </h6>
                                                    </React.Fragment>
                                                }
                                            >
                                                <Button size="small" onClick={this.handleAddHour} style={{ padding: '0px', marginBottom: '5px' }}>
                                                    <Typography>+ 1hr</Typography>
                                                </Button>
                                            </Tooltip>
                                        </Grid>
                                    </Grid>
                                </div>

                                <Grid container justifyContent="center" spacing={0}>
                                    <Grid item xs={12} style={{ paddingLeft: '7px' }}>
                                        <TimePicker
                                            value={this.state.value}
                                            //defaultValue={this.state.value}
                                            //defaultValue={moment()}
                                            showSecond={false}
                                            onChange={this.handleValueChange}
                                            use12Hours
                                            format={format}
                                        />
                                    </Grid>
                                </Grid>

                                {/*
                <TextField
                  autoFocus
                  required
                  margin="normal"
                  id="time"
                  label="Back by"
                  type="time" // material ui time picker
                  fullWidth
                  value={this.state.tempAwayTime}
                  onChange={this.handleChange('awayTime')}
                />
                */}

                                {invalidError}
                            </DialogContent>
                            <DialogActions style={{ margin: '0px' }}>
                                <Button onClick={this.handleDialogClose} color="primary" style={{ margin: '0px' }}>
                                    Cancel
                </Button>
                                <Button onClick={this.handleDialogOK} color="primary" style={{ margin: '0px' }}>
                                    Save
                </Button>
                            </DialogActions>
                        </Dialog>
                        <Menu
                            id="simple-menu2"
                            anchorEl={anchorEl}
                            open={Boolean(anchorEl)}
                            onClose={this.handleClose}
                            MenuListProps={{ style: { padding: '0px' } }}
                            TransitionProps={{ onExited: this.restoreTriggerFocus }}
                        >
                            {availableButton}
                            {unavailableButton}
                            {awayButton}
                        </Menu>
                        <Dialog
                            open={this.state.showChangeStatusDialog}
                            aria-labelledby="form-dialog-title"
                            style={{ margin: '5px !important' }}
                            PaperProps={{ style: { minWidth: '180px' } }}
                        >
                            <DialogTitle id="form-dialog-title" style={{ fontWeight: 'bold', paddingTop: '5px', paddingLeft: '5px', paddingBottom: '0px' }}>
                                <Typography style={{ fontSize: '17px' }}>
                                    Update Status
                </Typography>
                            </DialogTitle>
                            <DialogContent style={{ fontSize: '11px', paddingLeft: '5px', paddingRight: '5px', paddingBottom: '0px' }}>
                                Your return time has elapsed, please update your status!
              </DialogContent>
                            <DialogActions style={{ margin: '0px' }}>
                                <Button onClick={this.closeChangeStatusDialog} color="primary" style={{ margin: '0px', padding: '0px', fontSize: '10px' }}>
                                    CLOSE
                </Button>
                            </DialogActions>
                        </Dialog>
                    </Grid>

                    <Grid item xs={6} style={{ paddingLeft: '25px', paddingTop: '6px' }}>
                        <h4 style={{ 'cursor': 'default' }}>TeamX</h4>
                    </Grid>

                </Grid>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        profile: state.profile
    };
}

const mapDispatchToProps = dispatch => ({
    updateProfile: user => dispatch(getProfileFetch['UPDATE_PROFILE'](user))
})

/*
UserInfo.propTypes = {
    classes: PropTypes.object.isRequired,
};
*/
// export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(UserInfo));
export default connect(mapStateToProps, mapDispatchToProps)(UserInfo);


// WEBPACK FOOTER //
// ./src/components/UserInfo.js